<template>
  <transition v-if="found" name="fade" mode="out-in" appear>
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  data: () => ({
    found: false
  }),
  beforeMount () {
    this.beforeEnter()
  },
  methods: {
    beforeEnter () {
      const params = this.$route.params
      const url = params.contentUrl
      if (this.$store.getters.contentByUrl(url)) this.found = true
      else {
        const appMsg = {
          type: 'error',
          msg: 'Content not found'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/content')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/ContentWrap.vue